import React from 'react';
import type { Task, TaskLink, TaskPriority } from '../../api/tasks/interface';
import {
  Assignee,
  AssistChip,
  BlockedChip,
  DueChip,
  LinkChip,
  OwlChip,
  PriorityToggle,
  SnoozeControl,
  StreamCountChip,
  TagChips,
  TaskCheck,
  isDone,
} from './TaskBits';
import styles from './TasksTab.module.scss';

interface Props {
  task: Task;
  onToggle: () => void;
  onChangePriority: (p: TaskPriority) => void;
  onSnooze: (due: string) => void;
  onOpenLink?: (link: TaskLink) => void;
  onOpenDetail?: (taskId: string) => void;
  blockedBy?: Task[];
  activeTags?: string[];
  onTag?: (tag: string) => void;
}

const TaskRow: React.FC<Props> = ({
  task,
  onToggle,
  onChangePriority,
  onSnooze,
  onOpenLink,
  onOpenDetail,
  blockedBy = [],
  activeTags,
  onTag,
}) => {
  const done = isDone(task);
  const isAction = task.kind === 'action';
  return (
    <div
      className={`${styles.row} ${done ? styles.done : ''}`}
      role={onOpenDetail ? 'button' : undefined}
      tabIndex={onOpenDetail ? 0 : undefined}
      onClick={onOpenDetail ? () => onOpenDetail(task.id) : undefined}
      style={onOpenDetail ? { cursor: 'pointer' } : undefined}
    >
      <TaskCheck done={done} onToggle={onToggle} />
      <div className={styles.rowMain}>
        <div className={`${styles.rowTitle} ${done ? styles.doneTitle : ''}`}>
          {task.title}
        </div>
        <div className={styles.rowMeta}>
          {task.raised_by === 'Owl' ? <OwlChip /> : null}
          {!done ? <DueChip due={task.due} /> : null}
          <StreamCountChip task={task} />
          {isAction ? <AssistChip /> : null}
          {!done ? <BlockedChip blockers={blockedBy} /> : null}
          {task.link ? <LinkChip link={task.link} onOpen={onOpenLink} /> : null}
          <TagChips tags={task.tags} active={activeTags} onTag={onTag} />
        </div>
      </div>
      <div className={styles.rowSide}>
        {!done ? (
          <PriorityToggle
            priority={task.priority}
            onChange={onChangePriority}
          />
        ) : null}
        <Assignee name={task.assignee} />
        {!done ? <SnoozeControl onSnooze={onSnooze} /> : null}
      </div>
    </div>
  );
};

export default TaskRow;
